var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewAllNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40133_79392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9689 15.9375L28.2969 3.21592C28.1769 2.78242 27.7824 2.48242 27.3329 2.48242H4.35341C3.90041 2.48242 3.50391 2.78692 3.38641 3.22545L0.0304114 15.299C-0.0315886 15.5335 -0.00111986 15.7679 0.0928801 15.972C0.0388801 16.153 0.000911381 16.3415 0.000911381 16.54V27.5185C0.000911381 28.6229 0.896411 29.5185 2.00091 29.5185H30.0009C31.1054 29.5185 32.0009 28.6229 32.0009 27.5185V16.54C32.0009 16.4865 31.9894 16.4359 31.9854 16.3835C32.0114 16.24 32.0109 16.0885 31.9689 15.9375ZM5.12276 4.48245L26.5718 4.48242L29.4818 14.5399H21.1402C20.5952 14.5399 20.1638 14.9819 20.0424 15.5131C19.617 17.3756 18.07 18.5925 16.0008 18.5925C13.9317 18.5925 12.4076 17.3755 11.9885 15.5134C11.8688 14.9817 11.4373 14.54 10.8923 14.54H2.31825L5.12276 4.48245ZM30.0008 27.5184H2.00085V16.5399H10.2233C11.0963 19.0534 13.2163 20.5924 16.0008 20.5924C18.7853 20.5924 20.9363 19.0534 21.8093 16.5399H30.0008V27.5184Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40133_79392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAllNotifications);
export default __webpack_public_path__ + "static/media/view-all-notifications.f954b9c137bb779579bee3859827427e.svg";
export { ForwardRef as ReactComponent };